import React, { useCallback } from 'react';
import { CustomThemeButton } from '@atlaskit/button';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

type Props = {
	onTryAgain?: () => void;
	message: string;
	analyticsCellName?: string;
};

const LazySelectFetchError = ({ onTryAgain, message, analyticsCellName }: Props) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleOnTryAgain = useCallback(() => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'tryAgain', {
			cell: analyticsCellName,
		});
		onTryAgain && onTryAgain();
	}, [analyticsCellName, createAnalyticsEvent, onTryAgain]);

	return (
		<Flex xcss={wrapperStyles} alignItems="center" justifyContent="center">
			<Box xcss={errorMessageWrapperStyles}>{message}</Box>
			{onTryAgain && (
				<Flex>
					<CustomThemeButton
						appearance="link"
						spacing="none"
						onClick={(event) => {
							event.stopPropagation();
							handleOnTryAgain();
						}}
						theme={(currentTheme, theme) => {
							const buttonTheme = currentTheme(theme);
							return {
								...buttonTheme,
								buttonStyles: {
									...buttonTheme.buttonStyles,
									alignItems: 'center',
								},
							};
						}}
					>
						{formatMessage(messages.tryAgain)}
					</CustomThemeButton>
				</Flex>
			)}
		</Flex>
	);
};

export default LazySelectFetchError;

const wrapperStyles = xcss({
	height: token('space.600', '48px'),
	paddingLeft: 'space.150',
	paddingRight: 'space.150',
});

const errorMessageWrapperStyles = xcss({
	marginRight: 'space.100',
});
